import React from "react";
import LoadingButton from "@mui/lab/LoadingButton";
import SaveIcon from "@mui/icons-material/Save";
import ButtonOutlined from "../../requests/shared/helpers/ButtonOutlined";

// The app's standard drawer input treatment (see LogbookCategoryDrawer):
// white MUI fields, 8px radius, 45px single-line height, violet #6d28d9
// focused outline, and the stacked violet-Save / outlined-Cancel footer.

export const INPUT_SX = {
  backgroundColor: "white",
  borderRadius: "8px",
  padding: "5px",
  height: "45px",
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "#6d28d9",
  },
};

export const MULTILINE_SX = {
  backgroundColor: "white",
  borderRadius: "8px",
  padding: "8px",
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "#6d28d9",
  },
};

export const SELECT_SX = {
  backgroundColor: "white",
  borderRadius: "8px",
  padding: "5px",
  height: "45px",
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "#6d28d9",
  },
};

export const AUTOCOMPLETE_TEXTFIELD_SX = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "8px !important",
    minHeight: "45px",
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#6d28d9",
    },
    backgroundColor: "white",
  },
};

export const CHECKBOX_SX = {
  color: "#6d28d9",
  "&.Mui-checked": {
    color: "#6d28d9",
  },
};

export function DrawerLabel({ children }) {
  return <p className="text-sm text-slate-500">{children}</p>;
}

export function DrawerSaveFooter({ onSave, onClose, saving, saveText, horizontal, disabled }) {
  const saveButton = (
    <LoadingButton
      fullWidth
      loading={Boolean(saving)}
      disabled={Boolean(disabled)}
      loadingPosition="end"
      endIcon={<SaveIcon />}
      variant="contained"
      onClick={onSave}
      sx={{
        textTransform: "none",
        borderRadius: "12px",
        paddingY: "14px",
        backgroundColor: "#6d28d9",
        "&:hover": {
          backgroundColor: "#5b21b6",
        },
        fontSize: "16px",
      }}
    >
      {saveText || "Save"}
    </LoadingButton>
  );

  // Wide drawers put the buttons side by side; the standard 450px drawers
  // keep the stacked arrangement.
  if (horizontal) {
    return (
      <div className="w-full flex items-stretch gap-3">
        <div className="flex-1">
          <ButtonOutlined text="Cancel" onClick={onClose} />
        </div>
        <div className="flex-1">{saveButton}</div>
      </div>
    );
  }

  return (
    <>
      <div className="w-full">{saveButton}</div>
      <div className="w-full mt-3">
        <ButtonOutlined text="Cancel" onClick={onClose} />
      </div>
    </>
  );
}
